import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { IJsonWebToken } from "../DTOs/IJsonWebToken";

const AUTH_COOKIE_NAME = "mediti-token";
const USER_COOKIE_NAME = "mediti-user";

export const authService = {
  setToken(token: string) {
    Cookies.set(AUTH_COOKIE_NAME, token, {
      secure: true,
      sameSite: "strict",
    });
  },

  setUserData(name: string, id: string) {
    var value = "" + id + "|"+ name;
    Cookies.set(USER_COOKIE_NAME, value, {
      secure: true,
      sameSite: "strict",
    });
  },

  getToken() {
    return Cookies.get(AUTH_COOKIE_NAME);
  },

  removeCookies() {
    Cookies.remove(AUTH_COOKIE_NAME);
    Cookies.remove(USER_COOKIE_NAME);
  },

  isAuthenticated() {
    const token = this.getToken();
    if (!token) return false;

    try {
      const decoded = jwtDecode(token);
      return decoded.exp! * 1000 > Date.now();
    } catch {
      return false;
    }
  },

  getUserData(): IJsonWebToken | null {
    const userCookie = Cookies.get(USER_COOKIE_NAME);
    if (!userCookie) return null;

    try {
      const data = userCookie.split("|");

      let userData: IJsonWebToken = {
        id: data[0],
        name: data[1],
        accessToken: "",
        refreshToken: "",
        expires: 0,
        role: "",
        email: ""
      }

      return userData;
    } catch {
      return null;
    }
  },
};